<template>
  <div class="container">
    <h1>Subscription Details</h1>
    <sdx-tabs>
      <sdx-tabs-item label="SMS">
        <div class="row margin-bottom-2 margin-bottom-1">
          <div class="col-xs-4">
            <DevAppDropDownComponent dataTestId="devAppDropDownSms" role="sms" @devapp-changed="devAppChangedSms"/>
          </div>
        </div>
        <sdx-loading-spinner id="spinner-subscription-content-sms" size="large"
                             sr-hint="Loading. Please wait." style="display: none"></sdx-loading-spinner>
        <div id="subscription-content-sms" v-if="showSubscriptionSms" class="margin-top-4">
          <div class="row padding-1">
            <div class="col-xs-4 font--semi-bold ">SMS National Sender Text</div>
            <div class="col-xs-4">{{ subscriptionDetailsSms.scs_messaging_sms_v2_domesticSenderText }}</div>
          </div>
          <div class="row margin-top-1 padding-1 bg-horizon">
            <div class="col-xs-4 font--semi-bold">SMS International Sender Text</div>
            <div class="col-xs-4">{{ subscriptionDetailsSms.scs_messaging_sms_v2_internationalSenderText }}</div>
          </div>
          <div class="row padding-1 margin-top-1"
               v-if="subscriptionDetailsSms.scs_messaging_sms_v2_internationalSenderText_registered_numeric">
            <div class="col-xs-4 margin-left-1">
              Override for countries<br/>which have SMS registration as a numeric sender text
            </div>
            <div class="col-xs-4 col-align-bottom">
              <br/>
              {{ subscriptionDetailsSms.scs_messaging_sms_v2_internationalSenderText_registered_numeric }}
            </div>
          </div>
          <div class="row padding-1 margin-top-1 bg-horizon"
               v-if="subscriptionDetailsSms.scs_messaging_sms_v2_internationalSenderText_registered_alphanumeric">
            <div class="col-xs-4 margin-left-1">
              Override for countries<br/>which have SMS registration as an alphanumeric sender text
            </div>
            <div class="col-xs-4 col-align-bottom">
              <br/>
              {{ subscriptionDetailsSms.scs_messaging_sms_v2_internationalSenderText_registered_alphanumeric }}
            </div>
          </div>
          <div v-if="subscriptionDetailsSms.scs_messaging_sms_v2_price_swisscom">
            <div class="row margin-top-3">
              <div class="col-xs-4 font--semi-bold">SMS price</div>
            </div>
            <div class="row padding-1 margin-top-0 bg-horizon">
              <div class="col-xs-4 font--semi-bold margin-left-1">for Swisscom recipient</div>
              <div class="col-xs-4">{{ subscriptionDetailsSms.scs_messaging_sms_v2_price_swisscom }}</div>
            </div>
            <div class="row padding-1 margin-top-0">
              <div class="col-xs-4 font--semi-bold margin-left-1">for recipient in Switzerland</div>
              <div class="col-xs-4">{{ subscriptionDetailsSms.scs_messaging_sms_v2_price_national }}</div>
            </div>
            <div class="row padding-1 margin-top-0 bg-horizon">
              <div class="col-xs-4 font--semi-bold margin-left-1">for international recipient</div>
              <div class="col-xs-4">{{ subscriptionDetailsSms.scs_messaging_sms_v2_price_international }}</div>

            </div>
          </div>
        </div>
      </sdx-tabs-item>
      <sdx-tabs-item label="Receive SMS">
        <div class="row margin-bottom-2 margin-bottom-1">
          <div class="col-xs-4">
            <DevAppDropDownComponent dataTestId="devAppDropDownReceiveSms" role="receive_sms" @devapp-changed="devAppChangedReceiveSms"/>
          </div>
        </div>
        <sdx-loading-spinner id="spinner-subscription-content-receive-sms" size="large"
                             sr-hint="Loading. Please wait." style="display: none"></sdx-loading-spinner>
        <div id="subscription-content-receive-sms" v-if="showSubscriptionReceiveSms" class="margin-top-4">
          <div class="row padding-1">
            <div class="col-xs-4 font--semi-bold ">Reply Phone Number</div>
            <div class="col-xs-4">{{ subscriptionDetailsReceiveSms.scs_messaging_sms_v2_replyNumber }}</div>
          </div>
          <div class="row padding-1  bg-horizon">
            <div class="col-xs-4 font--semi-bold ">Is Phone Number exclusive</div>
            <div class="col-xs-4">{{ subscriptionDetailsReceiveSms.scs_messaging_sms_v2_isExclusive }}</div>
          </div>
        </div>
        <div v-if="subscriptionDetailsReceiveSms.scs_messaging_sms_v2_price_swisscom">
          <div class="row margin-top-3">
            <div class="col-xs-4 font--semi-bold">SMS price</div>
          </div>
          <div class="row padding-1 margin-top-0 bg-horizon">
            <div class="col-xs-4 font--semi-bold margin-left-1">for Swisscom recipient</div>
            <div class="col-xs-4">{{ subscriptionDetailsReceiveSms.scs_messaging_sms_v2_price_swisscom }}</div>
          </div>
          <div class="row padding-1 margin-top-0">
            <div class="col-xs-4 font--semi-bold margin-left-1">for recipient in Switzerland</div>
            <div class="col-xs-4">{{ subscriptionDetailsReceiveSms.scs_messaging_sms_v2_price_national }}</div>
          </div>
          <div class="row padding-1 margin-top-0 bg-horizon">
            <div class="col-xs-4 font--semi-bold margin-left-1">for international recipient</div>
            <div class="col-xs-4">{{ subscriptionDetailsReceiveSms.scs_messaging_sms_v2_price_international }}</div>

          </div>
        </div>
      </sdx-tabs-item>
      <sdx-tabs-item label="Campaigns">
        <div class="row margin-bottom-2 margin-bottom-1">
          <div class="col-xs-4">
            <DevAppDropDownComponent dataTestId="devAppDropDownCampaigns" role="campaign_manager" @devapp-changed="devAppChangedCampaigns"/>
          </div>
        </div>
        <sdx-loading-spinner id="spinner-subscription-content-campaigns" size="large"
                             sr-hint="Loading. Please wait." style="display: none"></sdx-loading-spinner>
        <div id="subscription-content-campaigns" v-if="showSubscriptionCampaigns" class="margin-top-4">
          <div class="row padding-1">
            <div class="col-xs-4 font--semi-bold ">SMS National Sender Text</div>
            <div class="col-xs-4">{{ subscriptionDetailsCampaigns.scs_messaging_sms_v2_domesticSenderText }}</div>
          </div>
          <div class="row margin-top-1 padding-1 bg-horizon">
            <div class="col-xs-4 font--semi-bold">SMS International Sender Text</div>
            <div class="col-xs-4">{{ subscriptionDetailsCampaigns.scs_messaging_sms_v2_internationalSenderText }}</div>
          </div>
          <div class="row padding-1 margin-top-1"
               v-if="subscriptionDetailsCampaigns.scs_messaging_sms_v2_internationalSenderText_registered_numeric">
            <div class="col-xs-4 margin-left-1">
              Override for countries<br/>which have SMS registration as a numeric sender text
            </div>
            <div class="col-xs-4 col-align-bottom">
              <br/>
              {{ subscriptionDetailsCampaigns.scs_messaging_sms_v2_internationalSenderText_registered_numeric }}
            </div>
          </div>
          <div class="row padding-1 margin-top-1 bg-horizon"
               v-if="subscriptionDetailsCampaigns.scs_messaging_sms_v2_internationalSenderText_registered_alphanumeric">
            <div class="col-xs-4 margin-left-1">
              Override for countries<br/>which have SMS registration as an alphanumeric sender text
            </div>
            <div class="col-xs-4 col-align-bottom">
              <br/>
              {{ subscriptionDetailsCampaigns.scs_messaging_sms_v2_internationalSenderText_registered_alphanumeric }}
            </div>
          </div>
          <div v-if="subscriptionDetailsCampaigns.scs_messaging_sms_v2_price_swisscom">
            <div class="row margin-top-3">
              <div class="col-xs-4 font--semi-bold">SMS price</div>
            </div>
            <div class="row padding-1 margin-top-0 bg-horizon">
              <div class="col-xs-4 font--semi-bold margin-left-1">for Swisscom recipient</div>
              <div class="col-xs-4">{{ subscriptionDetailsCampaigns.scs_messaging_sms_v2_price_swisscom }}</div>
            </div>
            <div class="row padding-1 margin-top-0">
              <div class="col-xs-4 font--semi-bold margin-left-1">for recipient in Switzerland</div>
              <div class="col-xs-4">{{ subscriptionDetailsCampaigns.scs_messaging_sms_v2_price_national }}</div>
            </div>
            <div class="row padding-1 margin-top-0 bg-horizon">
              <div class="col-xs-4 font--semi-bold margin-left-1">for international recipient</div>
              <div class="col-xs-4">{{ subscriptionDetailsCampaigns.scs_messaging_sms_v2_price_international }}</div>

            </div>
          </div>
        </div>
      </sdx-tabs-item>
      <sdx-tabs-item label="Email">
        <div class="row margin-bottom-2 margin-bottom-1">
          <div class="col-xs-4">
            <DevAppDropDownComponent dataTestId="devAppDropDownEmail" role="email" @devapp-changed="devAppChangedEmail"/>
          </div>
        </div>
        <sdx-loading-spinner id="spinner-subscription-content-email" size="large"
                             sr-hint="Loading. Please wait." style="display: none"></sdx-loading-spinner>
        <div id="subscription-content-email" v-if="showSubscriptionEmail" class="margin-top-4">
          <div class="row padding-1">
            <div class="col-xs-4 font--semi-bold ">Email Sender Address</div>
            <div class="col-xs-4">{{ subscriptionDetailsEmail.scs_messaging_sms_v2_email_from }}</div>
          </div>
        </div>
      </sdx-tabs-item>
    </sdx-tabs>
  </div>
</template>


<script>
import subscriptionService from '../service'
import loadingSpinnerService from '@/services/loading-spinner.service';
import DevAppDropDownComponent from "@/components/DevAppDropDownComponent";
import {showAlert} from "@/services/notification.service";

export default {
  components: {
    DevAppDropDownComponent,
  },
  data: function () {
    return {
      webIdSms: undefined,
      webIdReceiveSms: undefined,
      webIdCampaigns: undefined,
      webIdEmail: undefined,
      subscriptionDetailsSms: [],
      subscriptionDetailsReceiveSms: [],
      subscriptionDetailsCampaigns: [],
      subscriptionDetailsEmail: [],
      showSubscriptionSms: false,
      showSubscriptionReceiveSms: false,
      showSubscriptionCampaigns: false,
      showSubscriptionEmail: false,
    }
  },
  created() {

  },
  methods: {
    devAppChangedSms: async function (webId) {
      this.webIdSms = webId;
      await this.loadDataSms();
    },
    devAppChangedReceiveSms: async function (webId) {
      this.webIdReceiveSms = webId;
      await this.loadDataReceiveSms();
    },
    devAppChangedCampaigns: async function (webId) {
      this.webIdCampaigns = webId;
      await this.loadDataCampaigns();
    },
    devAppChangedEmail: async function (webId) {
      this.webIdEmail = webId;
      await this.loadDataEmail();
    },
    loadDataSms: async function () {
      loadingSpinnerService.show("subscription-content-sms")
      if (this.webIdSms === undefined || this.webIdSms === null || this.webIdSms === '') {
        this.showSubscriptionSms = false
      } else {
        this.showSubscriptionSms = true;
        this.isLoading = true;

        try {
          let response = await subscriptionService.getSubscriptionDetails(this.webIdSms, "sms");
          this.subscriptionDetailsSms = response.data;
        } catch (error) {
          showAlert(error.message)
          this.subscriptionDetailsSms = []
        }
        this.isLoading = false;
      }
      loadingSpinnerService.hide("subscription-content-sms");
    },
    loadDataReceiveSms: async function () {
      loadingSpinnerService.show("subscription-content-receive-sms")
      if (this.webIdReceiveSms === undefined || this.webIdReceiveSms === null || this.webIdReceiveSms === '') {
        this.showSubscriptionReceiveSms = false
      } else {
        this.showSubscriptionReceiveSms = true;
        this.isLoading = true;

        try {
          let response = await subscriptionService.getSubscriptionDetails(this.webIdReceiveSms, "receive_sms");
          this.subscriptionDetailsReceiveSms = response.data;
        } catch (error) {
          showAlert(error.message)
          this.subscriptionDetailsReceiveSms = []
        }
        this.isLoading = false;
      }
      loadingSpinnerService.hide("subscription-content-receive-sms");
    },
    loadDataCampaigns: async function () {
      loadingSpinnerService.show("subscription-content-campaigns")
      if (this.webIdCampaigns === undefined || this.webIdCampaigns === null || this.webIdCampaigns === '') {
        this.showSubscriptionCampaigns = false
      } else {
        this.showSubscriptionCampaigns = true;
        this.isLoading = true;

        try {
          let response = await subscriptionService.getSubscriptionDetails(this.webIdCampaigns, "campaigns");
          this.subscriptionDetailsCampaigns = response.data;
        } catch (error) {
          showAlert(error.message)
          this.subscriptionDetailsCampaigns = []
        }
        this.isLoading = false;
      }
      loadingSpinnerService.hide("subscription-content-campaigns");
    },
    loadDataEmail: async function () {
      loadingSpinnerService.show("subscription-content-email")
      if (this.webIdEmail === undefined || this.webIdEmail === null || this.webIdEmail === '') {
        this.showSubscriptionEmail = false
      } else {
        this.showSubscriptionEmail = true;
        this.isLoading = true;

        try {
          let response = await subscriptionService.getSubscriptionDetails(this.webIdEmail, "email");
          this.subscriptionDetailsEmail = response.data;
        } catch (error) {
          showAlert(error.message)
          this.subscriptionDetailsEmail = []
        }
        this.isLoading = false;
      }
      loadingSpinnerService.hide("subscription-content-email");
    }


  }
};
</script>

<style>
.col-align-bottom {
  position: absolute;
  bottom: 0;
}

</style>
